import React, {Component, Fragment} from 'react'
import './track.less'
import {message, Form, Input, Checkbox, Tabs} from 'antd'
import {getOrderShort, getOrderDelivery, baseUrl,} from '../../api'
import axios from 'axios'
import DeliveryStep from '../../components/step/delivery-step'
import Gps from './gps'
import ajax from "../../api/ajax";
import RouteStepViewForm from "../route/route-step-view";
import VehicleDriver from "./vehicle-driver";
import {DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR, DEFAULT_CUSTOMS_CODE,} from '../../utills/constants'
import BoxInfoView from './box-info-v'
import TrackShortInfoView from './track-short-info-v'
const {TextArea} = Input;
const {TabPane} = Tabs;
class TrackDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: {},
            destinationCity: '',
            otherExplain: '',
            originAdd: '',
            destinaAdd: '',
            orderNodes: [],
            mapData: [],
            dataSource: [],
            oldGpsDataSource: [],
        };
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.setState({orderId});
        this.getOrderShortFunc(orderId);
        this.getOrderDeliveryInfo(orderId);
    };

    getOrderShortFunc = async (id) => {
        let result = await getOrderShort(id);
        if (result.code === 200) {
            let data = result.data;
            data.abnormal = result.data.abnormal === 'Y' ? true : false;
            this.setState({order: data,});
            const {dataSource2} = this.state;
            if (dataSource2 && dataSource2.length == 6) {
                let row = {
                    name: '到达' + data.destinationCity
                };
                const newData = [...this.state.dataSource2];
                const index = newData.findIndex(item => "5" === item.key);
                if (index > -1) {
                    const item = newData[index];
                    newData.splice(index, 1, {
                        ...item,
                        ...row,
                    });
                }
                this.setState({dataSource2: newData});
            }
            if (data.routeType === 'N') {
                this.getOrderNodes(id);
            }
        } else {
            message.error(result.message)
        }
    };
    getOrderDeliveryInfo = async (orderId) => {
        const result = await getOrderDelivery(orderId);
        if (result.code === 200) {
            if (result.data && result.data.length > 0) {
                this.setState({boxInfo: result.data[0], mapData: result.data,});
            } else {
                this.setState({boxInfo: {}});
            }
        } else {
            message.error(result.message)
        }
    };
    getVehicle = (pageNum, orderId) => {
        this.setState({
            page2: pageNum,// 保存pageNum, 让其它方法可以看到
            pageSize: 10
        });
        axios.get(baseUrl + '/api/v1/p/orderVehicleList', { // 配置对象
            params: {orderId: orderId, pageNum: pageNum, pageSize: this.state.pageSize2} // 指定请求参数
        }).then((res) => {
            let result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        total2: result.data.total,
                        vehicleDataSource: data,
                        vehicleCount: result.data.total
                    })
                }
            } else {
                message.error(result.message);
                return false;
            }
        });
    };
    getOrderNodes = async (orderId) => {
        this.setState({
            loading: true,
        });
        let result = await ajax(baseUrl + "/api/v1/p/wms/yg/orderNodes", {orderId});
        if (result && result.data) {
            let nodes = [];
            if (nodes) {
                nodes = result.data.nodeVos.sort((a, b) => {
                    return a.indx - b.indx
                })
            }
            this.setState({
                orderNodes: nodes,
                routeIOType: result.data.type,
            })
        } else {
            message.error("轨迹信息不存在！")
        }
        this.setState({
            loading: false
        })
    };

    render() {
        const {orderId, order, boxInfo, oldGpsDataSource, dataSource, mapData,} = this.state;
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 6},
            wrapperCol: {span: 14},
        };
        return (
            <div className='order-info info box-shadow padding-20'>
                <div className="head-title">
                    <span className='title'>物流详情</span>
                </div>
                <br/>
                <TrackShortInfoView order={order}/>
                <div className='info-item'>
                    <Tabs type="card" tabBarGutter={'16px'}>
                        <TabPane tab='轨迹' key="1">
                            <div className="info-item-title">
                                轨迹信息
                            </div>
                            <div className='info-item-content'>
                                {order.routeType === 'N' ?
                                    <RouteStepViewForm nodes={this.state.orderNodes} routeType={this.state.routeIOType}
                                                       readOnly={true} loading={this.state.loading}
                                                       reload={this.getOrderNodes}/>
                                    : <DeliveryStep {...this.props}/>}
                            </div>
                            <div className="info-item-title">轨迹展示</div>
                            <Gps orderId={orderId} mapData={mapData}/>
                        </TabPane>
                        <TabPane tab='其他' key="2">
                            <div className="info-item-title">
                                <div className='flex-between'>
                                    <div>集装箱信息</div>
                                </div>
                            </div>
                            <div className="info-item-content">
                                <BoxInfoView boxInfo={boxInfo}
                                             deliveryType={order.deliveryType}
                                             subType={order.subType}
                                             volume={order.volume}/>
                            </div>
                            <div className="info-item-title">
                                <div className='flex-between'>
                                    <div>车辆信息</div>
                                </div>
                            </div>
                            <div className="info-item-content">
                                <div className="info-item-content flex-between">
                                    <VehicleDriver orderId={orderId} orderNo={order.orderNo}
                                                   deliveryType={order.deliveryType} type="I"/>
                                    {order.deliveryType === 'D'
                                    || DELIVERY_TYPE_HIGHWAY.hasOwnProperty(order.deliveryType)
                                    || DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                                        <VehicleDriver orderId={orderId} orderNo={order.orderNo}
                                                       deliveryType={order.deliveryType} type="O"
                                                       exterior={false}/> : null}
                                </div>
                            </div>
                            <div className="info-item-title">
                                <div className='flex-between'>
                                    <div>其他说明</div>
                                </div>
                            </div>
                            <div style={{marginTop: '20px'}}>
                                <Form {...formItemLayout}>
                                    <Form.Item label="异常情况">
                                        {getFieldDecorator('abnormal', {
                                            valuePropName: 'checked',
                                            initialValue: order.abnormal,
                                        })(<Checkbox disabled={true}>异常</Checkbox>)}
                                    </Form.Item>
                                    <Form.Item label="内部说明">
                                        {getFieldDecorator('otherExplain', {
                                            initialValue: order.otherExplain,
                                        })(<TextArea style={{height: '50px', resize: 'none'}} readOnly={true}/>)}
                                    </Form.Item>
                                    <Form.Item label="客户说明">
                                        {getFieldDecorator('clientExplain', {
                                            initialValue: order.clientExplain,
                                        })(<TextArea style={{height: '50px', resize: 'none'}} readOnly={true}/>)}
                                    </Form.Item>
                                    <Form.Item label="口岸备注">
                                        {getFieldDecorator('portRemarks', {
                                            initialValue: order.portRemarks,
                                        })(<TextArea style={{height: '50px', resize: 'none'}} readOnly={true}/>)}
                                    </Form.Item>
                                </Form>
                            </div>
                        </TabPane>
                    </Tabs>
                </div>
            </div>
        )
    }
}
const WrapTrackDetail = Form.create()(TrackDetail);
export default WrapTrackDetail